<template>
  <b-modal
    :id="`price-proposal-modal-${appendixId}`"
    title="Tạo mới"
    @hidden="resetForm"
    :hide-footer="true"
    size="lg"
  >
    <div>
      <div v-for="(device, index) in devices" :key="index" class="mb-3 p-3 border rounded">
        <div class="mb-2">
          <strong
            >Thiết bị: {{ device.displayName }} ({{ device.serialNumber }}) - giá cũ:
            {{ formatCurrency(device.price) }}</strong
          >
        </div>

        <div class="form-group">
          <label for="newPrice">Giá mới:</label>
          <b-form-input
            id="newPrice"
            v-model="device.newPrice"
            type="number"
            placeholder="Giá mới"
          ></b-form-input>
        </div>

        <div class="form-group">
          <label for="reason">Lý do:</label>
          <b-form-input
            id="reason"
            v-model="device.reason"
            placeholder="Nhập lý do thay đổi giá"
          ></b-form-input>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-4">
        <b-button
          variant="secondary"
          class="px-4 mr-2"
          @click="$bvModal.hide(`price-proposal-modal-${appendixId}`)"
        >
          Hủy
        </b-button>
        <b-button variant="primary" class="px-4" @click="submitForm">
          <b-spinner small v-if="isSubmitting" class="mr-1"></b-spinner>
          Tạo mới
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
  import { ContractService } from '@/services/contract.service'

  export default {
    name: 'PriceProposalModal',
    props: {
      appendixId: {
        type: String,
        required: true,
      },
      devicesListAdd: {
        type: Array,
        required: true,
        default: () => [],
      },
    },
    data() {
      return {
        devices: [],
        isSubmitting: false,
      }
    },
    methods: {
      showModal() {
        this.prepareDevicesData()
        this.$bvModal.show(`price-proposal-modal-${this.appendixId}`)
      },

      prepareDevicesData() {
        // Map the devices from props to our internal format
        this.devices = this.devicesListAdd.map(device => ({
          serialNumber: device.serialNumber,
          displayName: device.displayName || device.name,
          price: device.price || device.totalPrice || 0,
          newPrice: '',
          reason: '',
        }))
      },

      formatCurrency(value) {
        return new Intl.NumberFormat('vi-VN', {
          style: 'currency',
          currency: 'VND',
        }).format(value)
      },

      resetForm() {
        this.devices = []
        this.isSubmitting = false
      },

      async submitForm() {
        try {
          this.isSubmitting = true

          const payload = {
            appendixId: this.appendixId,
            devices: this.devices
              // .filter(device => device.newPrice && Number(device.newPrice) > 0)
              .map(device => ({
                serialNumber: device.serialNumber,
                newPrice: Number(device.newPrice) || 0,
                reason: device.reason,
                // oldPrice: device.price,
                // displayName: device.displayName
              })),
          }

          const response = await ContractService.createPriceProposal(payload)

          if (response.success) {
            this.$bvToast.toast('Tạo mới đề xuất sửa giá thành công', {
              title: 'Thông báo',
              variant: 'success',
              solid: true,
            })
            this.$emit('proposal-created')
            this.$bvModal.hide(`price-proposal-modal-${this.appendixId}`)
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.error('Error creating price proposal:', error)
          this.showFailMx(error.message)
        } finally {
          this.isSubmitting = false
        }
      },

      showFailMx(message) {
        this.$bvToast.toast(message || 'Đã xảy ra lỗi', {
          title: 'Thông báo',
          variant: 'danger',
          solid: true,
        })
      },
    },
  }
</script>
